import { AppSettings, CompanyInfo, EmployeeInfo, GeneralInfo, IncomeDetails, PayStubDetails } from "./pay-stub-details";
import { calculateEndDate, calculatePayDate, defaultPeriodStart, parseLocalDate } from "../../utils/date-calculator";

// A stub is for a period that has already been worked, so the seed starts one full Weekly period
// in the past: end date yesterday, pay date today. The Pay period step re-derives end + pay date
// from the start, so these three must stay consistent.
const seedPeriodType = "Weekly";
const seedStart = defaultPeriodStart(seedPeriodType);
const seedEnd = calculateEndDate(seedStart, seedPeriodType);
const seedPay = calculatePayDate(seedEnd);

const appSettings: AppSettings = {
    templateId: 0,
    nextTabStep: "template",
    canPrint: false,
    configPath: ""
};

const companyInfo: CompanyInfo = {
    companyName: "",
    companyEIN: "",
    companyAddress1: "",
    companyAddress2: "",
    companyCity: "",
    companyState: "",
    companyZipCode: "",
    companyLogo: "CompanyLogoHere",
    companyPhone: "",
    companyEmail: ""
};

const employeeInfo: EmployeeInfo = {
    employeeFirstName: "",
    employeeMiddleInitial: "",
    employeeLastName: "",
    employeeAddress1: "",
    employeeAddress2: "",
    employeeCity: "",
    employeeState: "",
    employeeZipCode: "",
    employeeSSN: "",
    employeeID: "",
    employeePhone: "",
    employeeEmail: "",
    employeeMarriedStatus: "single",
    employeeExemptions: 0,
    employeeHireDate: new Date("2025-01-01")
};

const incomeDetails: IncomeDetails = {
    annualSalary: 0,
    wageType: "Hourly", 
    hourlyRate: 0.0, // Example hourly rate
    hoursWorked: 0.0, // Example hours worked per week
    overtimeRate: 0.0, // Example overtime hourly rate
    overtimeHours: 0.0, // Example overtime hours worked per week
    bonusAmount: 0.0, // Example extrea bonus amount
    deduction401k: 0, // Optional 401K amount
    medicalDeduction: 0, // Optional medical deduction amount
    dentalDeduction: 0, // Optional dental deduction amount
    visionDeduction: 0, // Optional vision deduction amount
    otherDeduction: 0, // Optional other deduction amount
    unionDues: 0, // Optional union dues percentage (e.g., 0.01 for 1%)
    periodStartDate: parseLocalDate(seedStart),
    periodEndDate: parseLocalDate(seedEnd),
    periodPayDate: parseLocalDate(seedPay),
    periodType: seedPeriodType
};

const generalInfo: GeneralInfo = {
    employmentType: "",
    paymentMethod: "Physical Check",
    bankRoutingNumber: "",
    bankAccountType: "",
    bankAccountNumber: "",
    paymentFrequency: "",
    payStubCount: 0,
    payStubNumber: 1,
    extraNotes: "",
    checkNumber: 5001
};

export const prodInitialState: PayStubDetails = {
    appSettings: appSettings,
    companyInfo: companyInfo,
    employeeInfo: employeeInfo,
    incomeDetails: incomeDetails,
    generalInfo: generalInfo
};